import { render, staticRenderFns } from "./OauthLogin.vue?vue&type=template&id=c0a2c6d0&scoped=true&"
import script from "./OauthLogin.vue?vue&type=script&lang=js&"
export * from "./OauthLogin.vue?vue&type=script&lang=js&"
import style0 from "./OauthLogin.vue?vue&type=style&index=0&id=c0a2c6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2c6d0",
  null
  
)

export default component.exports